import { Box, styled, Text } from '@ltvco/refresh-lib/theme';
import React from 'react';

export const BannerContainer: React.ComponentType<
  React.ComponentProps<typeof Box>
> = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 'max-content',
  marginTop: '16px',
  paddingTop: '16px',
  paddingRight: '40px',
  paddingBottom: '16px',
  paddingLeft: '40px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    flexDirection: 'column',
    padding: '20px 16px',
    gap: '24px',
  },
}));

export const HeaderSection: React.ComponentType<
  React.ComponentProps<typeof Box>
> = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
}));

export const StyledBannerIcon: React.ComponentType<
  React.ComponentProps<'img'>
> = styled('img')(() => ({
  height: '65px',
  transform: 'translateX(-10px)',
  display: 'block',
}));

export const StyledTextContainer: React.ComponentType<
  React.ComponentProps<typeof Box>
> = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  width: '700px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledHeaderText: React.ComponentType<
  React.ComponentProps<typeof Text>
> = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const StyledBodyText: React.ComponentType<
  React.ComponentProps<typeof Text>
> = styled(Text)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.text.secondary,
  textAlign: 'center',
  maxWidth: '700px',
}));
